<template>
  <div>
    <PgReadText
      ref="readRef"
      :value="transfromValue"
      v-bind="$attrs"
      :type="formatType"
      :style="contentStyle"
      >{{ transfromValue }}</PgReadText
    >
    <PgClickToRouterByBiz :value="routerText" v-bind="$attrs"></PgClickToRouterByBiz>
  </div>
</template>

<script setup>
import PgReadText from './read-text.vue'
import { PgClickToRouterByBiz } from '../../click-to-router'
import { computed } from 'vue'

const props = defineProps({
  value: [String, Number, Boolean],
  //[{ "label": "启用", "value": true }, { "label": "停用", "value": false }]
  ruleArray: Array,
  // 支持default/info/white
  type: String,
  formatType: String,
  contentStyle: Object,
  routerText: [String, Number, Boolean],
})

const transfromValue = computed(() => {
  if (props.ruleArray && props.ruleArray.length > 0) {
    const rule = props.ruleArray.find((item) => item.value === props.value)
    if (rule) {
      return rule.label
    }
  }
  return props.value
})
</script>
<style lang="scss"></style>
